// cSpell:ignore Aangepast Gemeenschappelijke kosten maanden Provisies
// The columns of every card in the "Provisies" step, one card per unit
// (Lewis, 2026-10-16): the provision (the tenant on their own row, their
// lines indented under them), how its amount was calculated ("€ 55,00 × 6
// maanden") and the amount. The same headings in the same order and the same
// widths, so the cards line up under each other as the cost choice's do
// (INVOICE_SELECT_COLUMNS): a table sizes its columns by its own content, so
// each card would get other widths; a fixed layout on these widths keeps
// them equal. The provision column fits a line's indented checkbox and label
// ("Gemeenschappelijke kosten"), the amount column "Aangepast", an amount
// (or its input) and the area for a line's pencil and bin that comes after
// every amount (ProvisionAmount, 2026-10-17): the room for the bin comes
// from the provision column, which had it to spare.

// A table cell's padding on either side: DataTable's (horizontalSpacing
// "tight", spacing("tight")) and the grouped table's. A card's totals keep
// the same distance from its edge, so they end where the amounts do. A
// plain value: this module is read where web-theme's helpers are not.
export const CELL_PADDING = "8px";

// One column of a grouped table (ProvisionLinesTable's LinesTable).
export interface ILinesTableColumn {
  heading: string;
  width: string;
  contentType: "text" | "numeric";
}

const LABEL_WIDTH = "40%";
const CALCULATION_WIDTH = "32%";
const AMOUNT_WIDTH = "28%";

export const PROVISION_COLUMNS = [
  {
    heading: "settlement.provisions.column.provision",
    width: LABEL_WIDTH,
    contentType: "text",
  },
  {
    heading: "settlement.provisions.column.calculation",
    width: CALCULATION_WIDTH,
    contentType: "text",
  },
  {
    heading: "costs.field.amount",
    width: AMOUNT_WIDTH,
    contentType: "numeric",
  },
] as const;
